import { X } from 'lucide-react'
import { ClaimPropertyWizard } from '@/components/claim/ClaimPropertyWizard'
import { FadeModal } from '@/components/ui/fade-modal'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function ClaimPropertyModal({
  open,
  onClose,
  propertyId,
}: {
  open: boolean
  onClose: () => void
  propertyId?: string | null
}) {
  return (
    <FadeModal
      open={open}
      onClose={onClose}
      labelledBy="add-property-title"
      panelClassName="max-w-lg"
    >
      <Card className="relative w-full overflow-visible border-0 shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 z-10 rounded-lg p-2 text-muted transition hover:bg-surface hover:text-charcoal"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>

        <CardHeader className="pr-12">
          <CardTitle id="add-property-title">Add your property</CardTitle>
        </CardHeader>
        <CardContent className="overflow-visible">
          <ClaimPropertyWizard
            initialPropertyId={propertyId}
            onCancel={onClose}
            onComplete={onClose}
          />
        </CardContent>
      </Card>
    </FadeModal>
  )
}
